export default __webpack_public_path__ + "static/media/element_77.7185afa2.avif";